//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";

//modules

//services
// replace: \.(component|directive)\("(\w+)",\s*(\w+)\) with: $2,

//components
import tagPagination from "servicestack/tags/pagination/tag-pagination";

export const dependencies = [dropdown, collapse];

export const modules = {};

//const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const services = {};

export const components = {
  tagPagination,
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
};
